import * as actions from '../actions';
import { LOG_PREFIX } from '../resources';

export const getBookmarks = async (): Promise<BookmarkResponse> => {
  return handleApiResponse<BookmarkResponse>('/web/bookmarks');
};

// contentId is a shortId for normal articles, and the page url for KV articles.
export const putBookmarks = async (
  contentId: string,
  bookmarked: boolean
): Promise<BookmarkResponse> => {
  const payload = {
    changedOn: new Date().toISOString(),
    contentId,
    bookmarked,
  };

  return handleApiResponse<BookmarkResponse>('/web/bookmarks', {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify([payload]),
  });
};

export const getBookmarkList = async (
  lastTeaserNumber: number
): Promise<BookmarkListResponse> => {
  return handleApiResponse<BookmarkListResponse>(
    `/web/bookmarklist?lastTeaserNumber=${lastTeaserNumber}`
  );
};

export const getSessionFromNext = async (): Promise<NextSessionResponse> => {
  const url = location.origin + '/api/_next-api/v1/auth/session/';
  return handleApiResponse<NextSessionResponse>(url);
};

export const getUrlPatterns = async (): Promise<UrlPatternResponse> => {
  const resource = '/web/urlpatterns';

  return handleApiResponse<UrlPatternResponse>(resource);
};

const handleApiResponse = async <T>(
  endpoint: string,
  requestOptions: RequestInit = {}
): Promise<T> => {
  try {
    const response = await fetch(endpoint, requestOptions);

    if (!response.ok) {
      actions.fail();
      throw new Error(
        `${LOG_PREFIX}: ${response.status} ${response.statusText}`
      );
    }

    const body = await response.json();

    if (!body) {
      throw new Error(`response body not found`);
    }

    return body;
  } catch (error) {
    actions.fail();
    console.error(error);
    throw error;
  }
};
